// import React, { useEffect, useState } from "react";
// import Slidere from "./Slider";
// // import Dealsoftheday from "./Dealsoftheday";
// // import Banner from "./Banner";
// import Security from "./Security";
// import Footer from "./Footer";
// import Shearchbar from "./Shearchbar";
// // import Navbar from "./Navbar";
// // import FruitsandVagetables from "./FruitsandVagetables";
// import Manubar from "./Manubar";
// import secureLocalStorage from "./storage";
// import axios from "axios";
// import baseurl from "./Baseurl";
// import "./header.css";
// import Freshfruit from "./Freshfruit";
// import FlashDeals from "./FlashDeals";
// import BestAtStores from "./BestAtStores";
// import PopularBrands from "./PopularBrands";

// const Header = () => {
//   const [profile, setProfile] = useState(null);
//   const _id = secureLocalStorage.getItem("n_id");
//   const token = secureLocalStorage.getItem("n_token");

//   useEffect(() => {
//     if (!_id || !token) return;

//     const fetchProfile = async () => {
//       try {
//         const { data } = await axios.post(
//           `${baseurl[0].apiurl}get_user_profile`,
//           { user_id: _id },
//           { headers: { token } }
//         );

//         if (data?.result) {
//           setProfile(data.data);
//         } else {
//           console.warn("Profile fetch failed:", data?.msg);
//         }
//       } catch (error) {
//         console.error("Error fetching user profile:", error);
//       }
//     };

//     fetchProfile();
//   }, [_id, token]);

//   return (
//     <>
//       <div className="modal fade offcanvas-modal" id="exampleModal">
//         <div className="modal-dialog offcanvas-dialog">
//           <div className="modal-content">
//             <Manubar />
//           </div>
//         </div>
//       </div>

//       <header>
//         <Shearchbar userProfile={profile} />
//         {/* <Navbar /> */}
//       </header>

//       <main style={{ width: "100%", margin: "0 auto" }}>
//         <Slidere />
//         <Freshfruit />
//            {/* <Banner /> */}
//            <FlashDeals/>
//         {/* <Dealsoftheday /> */}
//         <BestAtStores/>
//         <PopularBrands/>
     
//       </main>

//       <Security />
//       <Footer />
//     </>
//   );
// };

// export default Header;




import React from "react";
import Slidere from "./Slider";
import Security from "./Security";
import Footer from "./Footer";
import Manubar from "./Manubar";
import "./header.css";
import Freshfruit from "./Freshfruit";
import FlashDeals from "./FlashDeals";
import BestAtStores from "./BestAtStores";
import PopularBrands from "./PopularBrands";

const Header = () => {
  return (
    <>
      <div className="modal fade offcanvas-modal" id="exampleModal">
        <div className="modal-dialog offcanvas-dialog">
          <div className="modal-content">
            <Manubar />
          </div>
        </div>
      </div>

      <main style={{ width: "100%", margin: "0 auto" }}>
        <Slidere />
        <Freshfruit />
        <FlashDeals />
        <BestAtStores />
        <PopularBrands />
      </main>

      <Security />
      <Footer />
    </>
  );
};

export default Header;
